<template>
  <div class="bg-default screen-home">
    <header-nav>
      <div class="header-center">
        <div class="header-logos">
          <img class="logo" src="./../assets/img/tdscore-logo.png" alt="TD Score">
          <icon class="logo" name="rockcontent-logo" />
        </div>

        <h1 class="header-title" v-opacity="loaded">Score</h1>
        <h2 class="header-subtitle">Índice de maturidade digital</h2>

        <v-button to="/intro" big arrow outline>Inicie o diagnóstico</v-button>
      </div>

      <div class="line-vertical-small"></div>
    </header-nav>

    <section class="box-white-float">
      <h1 class="title">
        Descubra o avanço da transformação <br> Digital em sua empresa
      </h1>
      <h2 class="subtitle">
        Uma ferramenta totalmente gratuita feita para você diagnosticar o índice de maturidade digital da sua organização em apenas alguns minutos.
      </h2>
    </section>

    <section class="insights-result" id="como-funciona">
      <div class="container">
        <h1 class="title">insights de resultado</h1>
        <div class="info">
          <div class="description">
            <div>Através de questionários simples, o TD Score oferece o resultado do desempenho atual da sua empresa e indicadores dos próximos passos a serem dados, baseado em 4 dimensões que respondem pela organização como um todo: Pessoas, Processos, Cliente e Estratégia.</div>
            <v-button to="/intro" dark outline>Descubra o seu score</v-button>
          </div>
          <div class="media">
            <video width="100%" autoplay loop src="./../assets/video/form.mp4"></video>
          </div>
        </div>
      </div>
    </section>

    <div class="container slide-vertical-home">
      <slide-vertical></slide-vertical>
    </div>

    <!-- <v-video full-width></v-video> -->

    <slide-horizontal id="new-strategy"></slide-horizontal>

    <v-footer></v-footer>

  </div>
</template>

<script>
import HeaderNav from './HeaderNav';
import Icon from './Icon';
import vButton from './vButton';
import SlideVertical from './SlideVertical';
import SlideHorizontal from './SlideHorizontal';
// import vVideo from './vVideo';
import vFooter from './vFooter';

export default {
  name: 'home',
  components: { HeaderNav, Icon, vButton, SlideVertical, SlideHorizontal, vFooter },
  data() {
    return {
      loaded: false,
    };
  },
  mounted() {
    setTimeout(() => { this.loaded = true; }, 200);
    this.$store.commit('SET_BAR_PROGRESS', 0);
  },
};
</script>

<style lang="scss" scoped>
  $color-title: #121416;

  .screen-home {
    overflow: hidden;
  }

  .header {
    .header-center {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .header-logos {
      display: flex;
      align-items: center;
      justify-content: center;
      .logo {
        transform: scale(.5);
      }
    }
  }

  .box-white-float {
    position: relative;
    z-index: 1;
    padding: 62px 52px;
    width: 80%;
    background-color: white;
    margin: -52px auto 0;
    text-align: center;
    @media (max-width: 576px) {
      margin: 0;
      padding-left: 26px;
      padding-right: 26px;
      width: auto;
    }
    .title {
      text-transform: uppercase;
      font-size: 20px;
      line-height: 28px;
      letter-spacing: 9px;
      text-indent: 9px;
      margin-bottom: 24px;
      color: $color-title;
    }
    .subtitle {
      font-size: 20px;
      line-height: 22px;
      width: 60%;
      margin: 0 auto;
      @media (max-width: 576px) {
        width: auto;
      }
    }
  }

  .insights-result {
    font-size: 18px;
    line-height: 30px;
    padding: 84px 0;
    .title {
      font-size: 24px;
      color: $color-title;
      letter-spacing: 10px;
      text-indent: 10px;
      text-align: center;
      text-transform: uppercase;
      margin-bottom: 42px;
    }
    .info {
      display: flex;
      align-items: center;
      @media (max-width: 576px) {
        flex-direction: column;
      }
      @media (min-width: 1200px) {
        width: 950px;
        margin: 0 auto;
      }
      .description {
        padding-right: 62px;
        width: 50%;
        @media (max-width: 576px) {
          width: auto;
          padding: 0;
        }
        /deep/ .button {
          margin-top: 28px;
          @media (max-width: 576px) {
            display: block;
            margin-bottom: 42px;
          }
        }
      }
      .media {
        width: 50%;
        align-self: stretch;
        @media (max-width: 576px) {
          width: auto;
        }
      }
    }
  }

  .slide-vertical-home {
    margin-top: 24px;
    margin-bottom: 124px;
    display: flex;
    justify-content: flex-end;
    .slide-vertical {
      right: 0;
      @media (min-width: 576px) {
        right: -5%;
      }
      @media (min-width: 950px) {
        right: -25%;
      }
      @media (min-width: 1170px) {
        right: -40%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue